// Power Dial API wrappers — thin layer over the apiGet/apiPost helpers so
// every call site uses the same paths and the routes are easy to grep.

import { apiGet, apiPost, apiPatch } from './api.js';

export const powerdialApi = {
  getActive: () => apiGet('/powerdial/sessions/active'),
  get: (id) => apiGet(`/powerdial/sessions/${id}`),
  getCallerIds: () => apiGet('/powerdial/caller-ids'),
  previewCallerIds: (leadIds) => apiPost('/powerdial/caller-ids/preview', { leadIds }),
  create: ({ leadIds, concurrency, redialAttempts, allowWarn = false, smartLocalId = true, outboundCallerId, batchSize, resumedFrom }) =>
    apiPost('/powerdial/sessions', {
      leadIds,
      concurrency,
      redialAttempts,
      allowWarn,
      smartLocalId,
      ...(outboundCallerId ? { outboundCallerId } : {}),
      ...(batchSize ? { batchSize } : {}),
      ...(resumedFrom ? { resumedFrom } : {}),
    }),
  update: (id, data) => apiPatch(`/powerdial/sessions/${id}`, data),
  // softphoneReady: the browser Device is registered. Required for multi-line
  // (concurrency>1) conference sessions — the backend blocks the start otherwise.
  start: (id, softphoneReady = false) =>
    apiPost(`/powerdial/sessions/${id}/start`, { softphoneReady }),
  pause: (id) => apiPost(`/powerdial/sessions/${id}/pause`, {}),
  resume: (id) => apiPost(`/powerdial/sessions/${id}/resume`, {}),
  skip: (id) => apiPost(`/powerdial/sessions/${id}/skip`, {}),
  cancel: (id) => apiPost(`/powerdial/sessions/${id}/cancel`, {}),
  // Agent-initiated hangup on the currently-connected leg. Used when the
  // dialer bridges into an undetected voicemail — lets the agent kick out
  // without force-refreshing (which lost session position).
  hangupConnected: (id, callSid) => apiPost(`/powerdial/sessions/${id}/hangup-connected`, callSid ? { callSid } : {}),
};
